

const filterContants = {
    "Last 3 Months": 90,  // Days from 2025-02-20 to 2025-05-20 inclusive
    "Last 6 Months": 182, // Days from 2024-11-20 to 2025-05-20 inclusive
    "Last 12 Months": 366,// Days from 2024-05-20 to 2025-05-20 inclusive (includes leap day in 2024)
    "Last 7 Days": 7,   // The last 7 days including today
    "Last 15 Days": 14, // The last 14 days including today
    "Last 30 Days": 30, // The last 30 days including today
    "Last 4 Weeks": 28, // 4 weeks * 7 days/week
    "Last 12 Weeks": 84,// 12 weeks * 7 days/week
    "Last 24 Weeks": 168// 24 weeks * 7 days/week
};


function getDaysDifference(dates) {
  const date1 = new Date(dates[0]);
  const date2 = new Date(dates[1]);

  // Check if the dates are valid
  if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
    console.error("Invalid date string provided.");
    return NaN;
  }

  // Set time to midnight for accurate day difference calculation
  date1.setHours(0, 0, 0, 0);
  date2.setHours(0, 0, 0, 0);

  // Calculate the difference in milliseconds
  const timeDifference = Math.abs(date2.getTime() - date1.getTime());

  // Convert milliseconds to days and return the floor value
  const daysDifference = timeDifference / (1000 * 60 * 60 * 24);

  return Math.floor(daysDifference);
}


export function filterAndMapScores(filterKey, data,dates) {
    console.log(dates);
    
  const result = {};
  // Use the actual current date instead of a hardcoded one
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  let daysInFilter

  if(filterKey==='Custom'){
 daysInFilter= getDaysDifference(dates)
  }else{
 daysInFilter= filterContants[filterKey];
  }


  if (daysInFilter === undefined) {
    console.error(`Filter key "${filterKey}" not found in filterContants.`);
    return {}; // Return empty object if filter key is invalid
  }

  // Calculate the start date by subtracting the number of days
  const startDate = new Date(today);
  startDate.setDate(today.getDate() - (daysInFilter - 1)); // Subtract days - 1 to include the start day
  startDate.setHours(0, 0, 0, 0);


  // Generate all dates in the specified range (inclusive) and initialize with 0
  const currentDate = new Date(startDate);
  while (currentDate <= today) {
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;
    result[dateString] = 0; // Initialize with 0

    currentDate.setDate(currentDate.getDate() + 1);
  }

  // Populate the result object with scores from the provided data
  data.forEach(item => {
    const executionDate = new Date(item.execution_date);
    executionDate.setHours(0, 0, 0, 0);

    // Check if the execution date is within the calculated range
    if (executionDate >= startDate && executionDate <= today) {
        const year = executionDate.getFullYear();
        const month = (executionDate.getMonth() + 1).toString().padStart(2, '0');
        const day = executionDate.getDate().toString().padStart(2, '0');
        const dateString = `${year}-${month}-${day}`;
        // Only update if the date exists in our generated range (which it should)
        if (result.hasOwnProperty(dateString)) {
             result[dateString] = item.total_dq_score;
        }
    }
  });

  return result;
}